import React from "react";
import classNames from "classnames";
import FormFooter from "@shared/ui/form-footer";
import { useDialogControls } from "../hooks/useDialogControls";
import { overlayTitleText } from "../overlayTitleText";
import "./MobileDialogFrame.scss";

/** Пропсы {@link MobileDialogFrame}. */
export interface MobileDialogFrameProps {
    title?: React.ReactNode;
    children?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    /** Показывает загрузку primary-действия и блокирует повторное подтверждение. */
    confirmLoading?: boolean;
    onConfirm?: () => void;
    onCancel?: () => void;
    className?: string;
}

/**
 * Центрированная dialog-surface для confirm и коротких blocking-сценариев на ТСД.
 */
export const MobileDialogFrame: React.FC<MobileDialogFrameProps> = ({
    title,
    children,
    confirmText = "Подтвердить",
    cancelText = "Отмена",
    confirmLoading = false,
    onConfirm,
    onCancel,
    className,
}) => {
    const dialogControls = useDialogControls();
    const handleCancel = () => {
        onCancel?.();
        dialogControls.close();
    };
    const handleConfirm = () => {
        onConfirm?.();
    };

    const titleText = overlayTitleText(title, "Подтверждение");

    return (
        <div
            className={classNames("mobile_dialog_frame", className)}
            role="dialog"
            aria-modal={dialogControls.blocking}
            aria-labelledby="mobile-dialog-title"
            style={{ zIndex: dialogControls.zIndex }}
        >
            <div className="mobile_dialog_frame__panel">
                <h2 id="mobile-dialog-title" className="mobile_dialog_frame__title">
                    {title != null && typeof title !== "string" && typeof title !== "number" ? title : titleText}
                </h2>
                <div className="mobile_dialog_frame__body">{children}</div>
                <FormFooter
                    className="mobile_dialog_frame__actions"
                    confirmText={confirmText}
                    cancelText={cancelText}
                    confirmLoading={confirmLoading}
                    cancelDisabled={confirmLoading}
                    onCancel={handleCancel}
                    onConfirm={handleConfirm}
                />
            </div>
        </div>
    );
};
